import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import testimonial from '../../images/testimonial.png'
import quote from '../../images/ft-icon/5.png'
import { Autoplay } from 'swiper';


const testimonials = [
    {
        id: '01',
        Des: "Yatri Interiors completely transformed the lighting in our home. Their team suggested modern fixtures and installed them with precision. The difference in ambiance is amazing, and everything works flawlessly. Highly recommended!",
        Title: ' Rohit Sharma',
        Sub: "Electrical & Lighting Solutions",
    },
    {
        id: '02',
        Des: " We hired Yatri Interiors for painting our office space, and they did a phenomenal job. The finish is smooth, the colors are vibrant, and their team worked with such attention to detail. They delivered on time without any hassle.",
        Title: 'Priya Nair,',
        Sub: "Painting Services",
    },
    {
        id: '03',
        Des: "Professional and reliable! The plumbing work done by Yatri Interiors was quick and long-lasting. They fixed issues other contractors couldn’t solve. I am really impressed with their expertise.",
        Title: 'Suresh Kumar',
        Sub: "Plumbing Work",
    },
    {
        id: '04',
        Des: "From electrical fittings to painting and carpentry, Yatri Interiors managed our entire project. The coordination was smooth, and the results exceeded our expectations. They truly made our house a home.",
        Title: 'Manoj Gupta',
        Sub: "Complete Interior Services",
    }
]

const Testimonial = (props) => {

    const settings = {
        dots: true,
        infinite: true,
        arrows: false,
        speed: 1000,
        fade: true,
        autoplay: true,
    };


    return (
        <div className={`section-padding ${props.tClass}`} >
            <div className="container">
                <div className="testimonial-wrapper">
                    <div className="row">
                        <div className="col-lg-6 col-12">
                            <div className="testimonial-slider">
                                <Slider {...settings}>
                                    {testimonials.map((testitem, titem) => (
                                        <div className="testimonial-text" key={titem}>
                                            <img src={quote} alt="" />
                                            <p>{testitem.Des}</p>
                                            <h3>{testitem.Title}</h3>
                                            <span>{testitem.Sub}</span>
                                        </div>
                                    ))
                                    }
                                </Slider>

                            </div>
                        </div>
                        <div className="col-lg-6 col-12">
                            <div className="testimonial-img">
                                <img src={testimonial} alt="" />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    );
}

export default Testimonial;







